export const smsMmsConsumption = "/analytics_dashboard/:app_group_id/sms_credit_consumption_detail_data";
